import { DynamicFieldConfig } from '../models';

export interface TextareaFieldConfig extends DynamicFieldConfig {
  rows?: number;
}
